import { Box, Button } from '@mui/material';
import React, { useState } from 'react';
import { SelfAppraisalLanding } from './SelfAppraisalLanding';
import useResponsive from '../../../Hooks/useResponsive';
import { ManagerAppraisalLanding } from './ManagerAppraisalLanding';
import ManagerUserListingLanding from './addEvaluationSelf/ManagerUserListingLanding';

const EvaluationLanding = () => {
  const cred = JSON.parse(localStorage.getItem('cred') || '{}');
  const isReportingHeadFromToken = cred?.profile?.isReportingHead;
  const mdUp = useResponsive('up', 'md');
  const childFontSize = mdUp ? '0.6rem' : '0.5rem';
  const [currentyUsedTabId, setCurrentyUsedTabId] = useState(1);

  const renderTheComponent = () => {
    if (currentyUsedTabId === 1) return <SelfAppraisalLanding />;
    if (currentyUsedTabId === 2) return <ManagerAppraisalLanding />;
    if (currentyUsedTabId === 3) return <ManagerUserListingLanding />;

    return null;
  };
  return (
    <>
      <Box
        p={mdUp ? 0.6 : 0.3}
        sx={{
          display: 'flex',
          gap: 1,
          height: '32px',
        }}
      >
        <Button
          disableElevation
          variant={currentyUsedTabId == 1 ? 'contained' : 'outlined'}
          size="small"
          onClick={() => setCurrentyUsedTabId(1)}
          sx={{
            fontSize: childFontSize,
            boxShadow: 'none',
            borderRadius: 2,
            px: mdUp ? 3 : 1,
          }}
          color="secondary"
        >
          Self Appraisal
        </Button>
        {isReportingHeadFromToken && (
          <Button
            variant={currentyUsedTabId == 2 ? 'contained' : 'outlined'}
            onClick={() => setCurrentyUsedTabId(2)}
            sx={{
              fontSize: childFontSize,
              boxShadow: 'none',
              borderRadius: 2,
              px: mdUp ? 3 : 1,
            }}
            color="secondary"
          >
            Manager Appraisal
          </Button>
        )}

        {/* <Button
          variant={currentyUsedTabId == 2 ? 'contained' : 'outlined'}
          onClick={() => setCurrentyUsedTabId(2)}
          sx={{
            fontSize: childFontSize,
            boxShadow: 'none',
            borderRadius: 2,
            px: mdUp ? 3 : 1,
          }}
          color="secondary"
        >
          Appraisal Users
        </Button> */}
      </Box>

      <Box>{renderTheComponent()}</Box>
    </>
  );
};

export default EvaluationLanding;
